import React from 'react';
import Cookies from 'js-cookie';


export const removeSession = () => {
    Cookies.remove('sessionFile');
    Cookies.remove('signees');
    
}

export const removeJWT = () => {
    Cookies.remove('jwt');
}